export default {
  title: 'How would you like to order?',
  options: {
    dine_in: 'Dine-in',
    takeaway: 'Pickup / Delivery',
  },
};
